import React from 'react';
import PropTypes from 'prop-types';

import Button from '@component/form/element/button';

const Action = ({ action, title, subTitle, className }) => {
  const mainAction = action.alternativeAction ? (
    action.alternativeAction
  ) : (
    <Button onClick={action.callback} text={action.text} />
  );
  const classNames = ['preview__bar'];
  if (className) {
    classNames.push(className);
  }
  return (
    <div className={classNames.join(' ')}>
      <div className="preview__meta">
        <div className="preview__title">{title}</div>
        <div className="preview__subtitle">{subTitle}</div>
      </div>
      {mainAction}
    </div>
  );
};

Action.propTypes = {
  action: PropTypes.object,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Action;
